<!-- Built with Common Launchpad 4.0.2 -->

<template>
	<section>
		<filters :data="filters"/>
		<div v-if="listing.length" class="filter-listing-grid">
      <content-item v-for="(item, index) in listing" :item="item" :key="item.DetailID"/>
    </div>
    <div v-else class="filter-listing-empty">
      <h2>No Results</h2>
      <p>Sorry, there are no results matching your Sort and Filter criteria.</p>
      <button @click="resetSearch()">Reset Filters</button>
    </div>
    <pagination/>
  </section>
</template>

<script>
	import SmoothScroll from 'smooth-scroll';
	import { mapState, mapActions, mapMutations } from 'vuex';
	import Pagination from './components/pagination.vue';
  import ContentItem from './components/content-item.vue';
  import Filters from './components/filters/filters.vue';

  import resourceFilter from '../../filters/resource-filter';
  import eventFilter from '../../filters/event-filter';
  import newsFilter from '../../filters/news-filter';

  import windowWidthMixin from './mixins/window-width';

	export default {
		props: ['filterid', 'type', 'result', 'resource'],
    mixins: [windowWidthMixin],
    data: function () {
			return {
				filters: {},
			}
		},
    components: {
      ContentItem,
      Pagination,
      Filters
    },
		computed: mapState({
			loading: state => state.listing.loading,
			listing: state => state.listing.listing,
			pagination: state => state.listing.pagination,
		}),
		methods: {
			...mapActions('listing', { setFilter: 'setFilter' }),
			...mapMutations('listing', { setInitData: 'setInitData' }),
			...mapMutations('listing', { setResource: 'setResource' }),
      ...mapMutations('listing', { navigateToUrl: 'navigateToUrl' }),
      ...mapMutations('listing', { resetSpecification: 'resetSpecification' }),
      resetSearch() {
        this.resetSpecification();
        this.navigateToUrl();
        this.setFilter();
      }
    },
    mounted() {
      let _this = this;
      // take props and send to vuex store    
      this.setInitData(this.result);
      this.setResource(this.resource);

      // import correct filters for this view based on prop value
      if (this.type === 'resource') {
        this.filters = resourceFilter;
      } else if (this.type === 'event') {
        this.filters = eventFilter;
      } else if (this.type === 'news') {
        this.filters = newsFilter;
      }

      // after filter comes back, scroll to the top
      let scroll = new SmoothScroll();
      let options = {
        header: '[data-scroll-header]',
        speed: 1000,
        offset: 96
      };

      // after any api calls, scroll to the top of the list
      this.$store.subscribeAction((action, state) => {
        if (action.type === 'listing/setFilter') {
          let anchor = document.querySelector('#' + _this.filterid);
          let header = document.getElementsByClassName('header')[0];

          scroll.animateScroll(anchor, null, options);

          setTimeout(() => {
            scroll.cancelScroll();
          }, 2000);
        }
      })

      // if each spec change should trigger a new api call, use this. else manually call setFilter action on button click
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'listing/updateSpecification') {
          if (this.isSmallScreen) return;
          this.setFilter();
        }
      });
    },
  }
</script>

<style lang="scss" scoped>
section {
  position: relative;
  z-index: 1;
  padding-bottom: 5.625rem;
  //padding: 3rem 0;
}
.filter-listing-grid {
  display: grid;
  margin-top: 24px;
  grid-template-columns: repeat(3, 1fr);
  gap: 2.5rem 1.5rem;

  @media (max-width: 991px) {
    display: flex;
    flex-direction: column;
    gap: 1.875rem;
  }
}
.filter-listing-empty {
  min-height: 20rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  h2 {
    text-align: center;
    margin: 0;
  }
  p {
    text-align: center;
    margin: 0;
  }
  button {
    margin: 0 auto;
  }
}
</style>